import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {ModalComponent} from "src/app/modules/core/components/modal/modal.component";

@Component({
  selector: "app-founder-premium-modal",
  templateUrl: "./founder-premium-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, TranslateModule],
})
export class FounderPremiumModalComponent {
  @Input({required: true}) modalId!: string;
  @Input() isMobile = false;
  @Output() continueRequested = new EventEmitter<void>();
}
